import React, { useLayoutEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Box } from '../../legacy/Box';
import { InlineLink } from '../InlineLink';
import { useMaxLines } from './hooks';
import css from './index.module.scss';

export interface ReadMoreProps {
  maxLines: number;
  content: string;
}

// This was modified from an open source project, which also had options like maxCharacters.
// For more info, see this site: https://morioh.com/p/deee1ea6ebf8
export const ReadMore: React.FC<ReadMoreProps> = ({ maxLines, content }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [text, setText] = useState<string>('');
  const { readMoreRef, buttonRef } = useMaxLines(maxLines, isOpen, content, setText);

  useLayoutEffect(() => {
    if (!isOpen && isAllText(text, content)) {
      setShowButton(false);
    } else {
      setShowButton(true);
    }
  }, [text, content, isOpen]);

  const handleClick = () => {
    setIsOpen(v => !v);
  };

  const getLabel = isOpen
    ? intl.formatMessage({ defaultMessage: 'less', id: 'ah2kTV' })
    : intl.formatMessage({ defaultMessage: 'more', id: 'gk3x/E' });
  return (
    <Box data-component="ReadMore" ref={readMoreRef} data-testid="wrapper" className={css.text}>
      {text}

      <Box inline className={css.wrapper} data-visible={showButton} ref={buttonRef}>
        {!isOpen ? '... ' : <span>&nbsp;</span>}
        <InlineLink type="button" onClick={handleClick}>
          {getLabel}
        </InlineLink>
      </Box>
    </Box>
  );
};

const isAllText = (truncatedText: string, text: string) =>
  truncatedText &&
  truncatedText.split('').filter(c => c !== ' ').length ===
    text.split('').filter(c => c !== ' ').length;
